export default "__VITE_ASSET__4aeeecbb__"